import React, { useEffect, useState } from 'react'
import services from '../../services'
import VinculoDialog, { ItemVinculo } from './VinculoDialog'

interface Vinculo { id: number; dashboardId: number; dashboard: string; ambienteId: number; ambiente: string; grupo: string }

let cache: ItemVinculo[] | null = null

const plural = (n: number, um: string, varios: string) => `${n} ${n === 1 ? um : varios}`

/**
 * Dá acesso a dashboards (cada um num ambiente) para pessoas e equipes de uma vez.
 * `ja` marca o que quem recebe já tem (quando é uma pessoa ou uma equipe só).
 */
export default function DarAcessoDialog({ aberto, pessoas = [], equipes = [], quem, ja = [], aoFechar, aoDar }: {
  aberto: boolean
  pessoas?: number[]
  equipes?: number[]
  /** "Ana Souza", "3 pessoas", "a equipe Supervisores Sul"… */
  quem: string
  ja?: number[]
  aoFechar: () => void
  aoDar: (mensagem: string) => void
}) {
  const [itens, setItens] = useState<ItemVinculo[] | null>(cache)

  useEffect(() => {
    if (!aberto || cache) return
    services.api.novoPortalVinculos().then((r: any) => {
      cache = r.fail ? null : (r.data || []).map((v: Vinculo) => ({
        id: String(v.id), nome: v.dashboard, sub: `${v.ambiente} · ${v.grupo}`, grupo: v.ambiente, busca: `${v.ambiente} ${v.grupo}`
      }))
      setItens(cache || [])
    })
  }, [aberto])

  const jaTem = new Set(ja.map(String))
  return (
    <VinculoDialog
      aberto={aberto}
      titulo="Dar acesso a dashboards"
      sub={`Para ${quem}`}
      carregando={!itens}
      abas={[{
        id: 'd', rotulo: 'Dashboards', dica: 'Buscar dashboard ou ambiente', unidade: ['dashboard', 'dashboards'],
        itens: (itens || []).map(i => ({ ...i, ja: jaTem.has(i.id) ? 'Já tem' : undefined }))
      }]}
      resumo={(sel, total) => total
        ? <>Acesso a <b>{plural(total, 'dashboard', 'dashboards')}</b> para <b>{quem}</b>. Onde o dashboard usa regra, cada pessoa vê só o recorte dela.</>
        : <>Cada item é um dashboard num ambiente. Busque pelo nome do dashboard ou do ambiente.</>}
      botao={total => total ? `Dar acesso a ${plural(total, 'dashboard', 'dashboards')}` : 'Dar acesso'}
      aoFechar={aoFechar}
      aoConfirmar={async sel => {
        const r = await services.api.novoPortalDarAcesso({ pessoas, equipes, vinculos: (sel.d || []).map(i => Number(i.id)) })
        if (r.fail) return r.error || 'Não foi possível dar o acesso.'
        aoDar(`${plural(r.data.criados, 'acesso dado', 'acessos dados')}${r.data.jaTinham ? `; ${r.data.jaTinham} já existiam` : ''}.`)
        return null
      }}
    />
  )
}
